import { render, staticRenderFns } from "./SaasOwnerDashboard.vue?vue&type=template&id=184c115a&scoped=true"
import script from "./SaasOwnerDashboard.vue?vue&type=script&lang=js"
export * from "./SaasOwnerDashboard.vue?vue&type=script&lang=js"
import style0 from "./SaasOwnerDashboard.vue?vue&type=style&index=0&id=184c115a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c115a",
  null
  
)

export default component.exports